var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSortBars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.375C0 0.753789 0.511786 0.25 1.14286 0.25H14.8571C15.4893 0.25 16 0.753789 16 1.375C16 1.99727 15.4893 2.5 14.8571 2.5H1.14286C0.511786 2.5 0 1.99727 0 1.375ZM0 7C0 6.37773 0.511786 5.875 1.14286 5.875H10.2857C10.9179 5.875 11.4286 6.37773 11.4286 7C11.4286 7.62227 10.9179 8.125 10.2857 8.125H1.14286C0.511786 8.125 0 7.62227 0 7ZM5.71429 13.75H1.14286C0.511786 13.75 0 13.2473 0 12.625C0 12.0027 0.511786 11.5 1.14286 11.5H5.71429C6.34643 11.5 6.85714 12.0027 6.85714 12.625C6.85714 13.2473 6.34643 13.75 5.71429 13.75Z",
    fill: "#4E4E4E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortBars);
export default __webpack_public_path__ + "static/media/sort-bars.e9e333ff18ba55ab068ee2903e35eace.svg";
export { ForwardRef as ReactComponent };